<template>
  <div class="lunch">
    <div class="cards__container">
      <div class="cards__single grayblue">
        <p class="cards__title">
          Lunch
        </p>
        <div class="cards__description">
          <p>12:00 PM - 2:00 PM</p>
        </div>
        <div class="cards__location">
          @ Patio del Fauno Lobby
        </div>
      </div>
    </div>
    <div class="cards__container">
      <div v-for="(speaker, index) in speakers" :key="index" class="cards__single cerulean" :class="speaker.class">
        <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
        <div v-if="speaker.imgClass" class="circle"></div>
        <div class="cards__speaker">
          <p class="cards__name">{{ speaker.name }}</p>
          <p class="cards__spktitle spkposition" v-if="speaker.position" v-html="speaker.position"></p>
          <p class="cards__spktitle" v-html="speaker.title"></p>
        </div>
        <div class="cards__description">
          <p class="time">{{ speaker.time }}</p>
          <p class="location">{{ speaker.location }}</p>
        </div>
      </div>
    </div>
  </div>
  <div :class="{'modal-show': isModalOpen}" v-if="isModalOpen" class="modal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h1 class="speaker">{{ activeCardInfo?.speaker }}</h1>
      <h2 class="title">{{ activeCardInfo?.title }}</h2>
      <p class="description" v-html="activeCardInfo?.description"></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Day Three Lunch',
  data() {
    return {
      eventDay: 3,
      speakers: [
        {
          imgClass: 'pojunis',
          name: 'Brett H. Pojunis',
          title: '"Principled Business"',
          position: 'Chairman of the Board & CEO - GPO Plus, Inc.',
          time: '12:00 PM - 12:30 PM',
          location: 'Patio del Fauno'
        },
        {
          imgClass: 'terpin',
          name: 'Michael Terpin',
          position: 'Founder and CEO - Transform Group, BitAngels',
          time: '1:00 PM - 1:45 PM',
          location: 'Patio del Fauno'
        },
        {
          imgClass: 'miglino',
          name: 'Chris Miglino',
          title: '"Closure"',
          position: 'President - DNA',
          time: '1:45 PM - 2:00 PM',
          location: 'Patio del Fauno'
        },
      ],
      cardData: {
      },
      activeCardInfo: null,
      isModalOpen: false
    }
  },
  methods: {
    openModal(cardId) {
      this.activeCardInfo = this.cardData[cardId];
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.activeCardInfo = null;
    }
  },
  computed: {
    current() {
      return new Date();
    }
  },
};
</script>